export default __webpack_public_path__ + "static/media/logo11.95bbeb37.png";